import React, { memo } from "react";
import style from "./cord-thread.module.css";
import { CordMessageContent } from "shared/datamodel/cord";

const RenderMessageItem = (item: CordMessageContent[number], index: number): React.ReactNode => {
  // Check if it's a text-only item
  if ("text" in item && !("type" in item)) {
    return <span key={index}>{item.text}</span>;
  }

  // It's a complex item with type and children
  if ("type" in item && "children" in item) {
    return <span key={index}>{item.children.map((child, childIndex) => RenderMessageItem(child, childIndex))}</span>;
  }

  return null;
};

export const CordMessage = memo(({ message }: { message: CordMessageContent }) => {
  return <div className={style.content}>{message.map((item, index) => RenderMessageItem(item, index))}</div>;
});

CordMessage.displayName = "CordMessage";
